// extracted by mini-css-extract-plugin
export default {"wrapper":"_1QQwQ","separator":"-UOsz","titleText":"_2TJuf"};